// import { User } from "@/models/user";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { TagState } from "@/types/tag";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import { Module } from "vuex";
import { Tag } from "@/models/tag";

const state: TagState = {
  single: new Tag(),
  pagination: new Pagination(),
};

export const tag: Module<TagState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
